import { FoundationType } from "./v1";

export type FoundationTypeV1Type = keyof typeof FoundationType;
export type FoundationTypeType = FoundationTypeV1Type;
